// "Tleskáček" / like příspěvku

import { FlashMessage } from '@components';
import * as els from './forumElements';
import * as api from './forumApi';
import * as Sentry from '@sentry/browser';
import { forumLikeAnimation } from './forumLikeAnimation';

interface ResponseSuccess {
  success: boolean;
  data: {
    userRating: number;
    plus: number;
  };
}
const CLASS_LIKE_COUNTED = 'likes-counter__icon-button--counted';

const sendLikeRequest = async (threadId: string, msg: string): Promise<ResponseSuccess | null> => {
  try {
    const response = await fetch(`${api.like(threadId)}?msg=${msg}&vote=1&ajax=1`, {
      method: 'GET',
    });
    const data: ResponseSuccess = await response.json();
    return data;
  } catch (error) {
    await FlashMessage({
      msg: 'Akci se nepodařilo zpracovat.',
      type: 'error',
    });
    Sentry.captureException(
      `forumLikeComment: Akci se nepodařilo zpracovat. Původní error: ${error}`
    );
    return null;
  }
};

export const forumLikeComment = () => {
  // Pro všechny tlačítka 'Tleskáček'
  els.buttonsLike.forEach((button) => {
    // Po kliknutí
    button.addEventListener('click', async () => {
      const { likeComment: msg, threadId } = button.dataset;

      forumLikeAnimation(button);

      // Kontrola, zda jsou data k dispozici
      if (!msg || !threadId) {
        console.error('Missing data attributes for like button');
        return;
      }

      // Odeslat požadavek
      const data = await sendLikeRequest(threadId, msg);
      if (!data || !data.success || !data.data) return;

      const { plus, userRating } = data.data;

      switch (userRating) {
        case 1:
          // Zabarvit tlačítko
          button.classList.add(CLASS_LIKE_COUNTED);
          break;

        default:
          // Odbarvit tlačítko
          button.classList.remove(CLASS_LIKE_COUNTED);
          break;
      }

      // Najít a nastavit novou hodnotu pro odpovídající likes-counter__text
      const counterElement = button.closest('.likes-counter');
      const span = counterElement?.querySelector('.likes-counter__text') ?? null;
      if (span) span.innerHTML = plus.toString();
    });
  });
};
